//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_TIPOS_ELEMENTO = "obteneTiposElemento";

// mutation types
export const SET_TIPOS_ELEMENTO = "setTiposElemento";
export const SET_TIPO_ELEMENTO = "setTipoElemento";

const state = {
    tiposElemento:[],
 }
const getters = {
    obtenerTiposElemento(state) {
      return state.tiposElemento;
    },
} 

const actions = {
    async [OBTENER_TIPOS_ELEMENTO](context, estadoId) {
        
        let endpoint = `api/TipoElemento`;
        if(estadoId!=0){
            endpoint = `api/TipoElemento/Estado/${estadoId}`
        }
        //console.log(endpoint)
        return new Promise(resolve => {
            ApiService.query(`apiconsume/obtener?endpoint=${endpoint}`, '')
                .then(({ data }) => {
                    context.commit(SET_TIPOS_ELEMENTO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    resolve(error)
                });
        });   
    
    }
}

const mutations = {
    [SET_TIPOS_ELEMENTO](state, data) {
        state.tiposElemento = data;
    },

    [SET_TIPO_ELEMENTO](state, data) {
        state.tipElemento = data;
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}